import React from 'react';
import PropTypes from 'prop-types';

import ExportButton from './ExportButton.jsx';

function ExportCommissions({ selectedRep, selectedYear, selectedMonth }) {
  const url = `/api/export-commissions/${selectedRep}/${selectedYear}`;
  const queryParams = selectedMonth ? { month: selectedMonth } : {};
  const filename = `commissions-${selectedRep}-${selectedYear}-${selectedMonth || 'all'}.csv`;

  return (
    <ExportButton
      url={url}
      queryParams={queryParams}
      filename={filename}
      disabled={!selectedRep || !selectedYear}
      data-cy="export-commissions-button"
    />
  );
}

ExportCommissions.propTypes = {
  selectedRep: PropTypes.string,
  selectedYear: PropTypes.number,
  selectedMonth: PropTypes.number,
};

export default React.memo(ExportCommissions);
